import { FeatureLogger } from "../utils/feature-logger";

const name = "product-filter-tracking";

export const logger = new FeatureLogger(name);
